export default {
  en: {
    user: 'User Management'
  },
  th: {
    user: 'การจัดการผู้ใช้'
  }
}
